var StringScanner;

StringScanner = (function() {
  function StringScanner(str1) {
    this.str = str1 != null ? str1 : '';
    this.str = '' + this.str;
    this.pos = 0;
    this.lastMatch = {
      reset: function() {
        this.str = null;
        this.captures = [];
        this.start = -1;
        return this;
      }
    }.reset();
    this;
  }

  StringScanner.prototype.bol = function() {
    return this.pos <= 0 || (this.str[this.pos - 1] === "\n");
  };

  StringScanner.prototype.captures = function() {
    return this.lastMatch.captures;
  };

  StringScanner.prototype.check = function(pattern) {
    var matches;
    if (this.str.substr(this.pos).search(pattern) !== 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos).match(pattern);
    this.lastMatch.str = matches[0];
    this.lastMatch.start = this.str.indexOf(matches[0]);
    this.lastMatch.captures = matches.slice(1);
    return this.lastMatch.str;
  };

  StringScanner.prototype.checkUntil = function(pattern) {
    var matches, patternPos;
    patternPos = this.str.substr(this.pos).search(pattern);
    if (patternPos < 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos + patternPos).match(pattern);
    this.lastMatch.captures = matches.slice(1);
    this.lastMatch.start = patternPos;
    return this.lastMatch.str = this.str.substr(this.pos, patternPos) + matches[0];
  };

  StringScanner.prototype.clone = function() {
    var clone, prop, ref, value;
    clone = new this.constructor(this.str);
    clone.pos = this.pos;
    clone.lastMatch = {};
    ref = this.lastMatch;
    for (prop in ref) {
      value = ref[prop];
      clone.lastMatch[prop] = value;
    }
    return clone;
  };

  StringScanner.prototype.concat = function(str) {
    this.str += str;
    return this;
  };

  StringScanner.prototype.eos = function() {
    return this.pos === this.str.length;
  };

  StringScanner.prototype.exists = function(pattern) {
    var matches, patternPos;
    patternPos = this.str.substr(this.pos).search(pattern);
    if (patternPos < 0) {
      this.lastMatch.reset();
      return null;
    }
    matches = this.str.substr(this.pos + patternPos).match(pattern);
    this.lastMatch.str = matches[0];
    this.lastMatch.captures = matches.slice(1);
    return patternPos;
  };

  StringScanner.prototype.getch = function() {
    return this.scan(/./);
  };

  StringScanner.prototype.match = function() {
    return this.lastMatch.str;
  };

  StringScanner.prototype.matches = function(pattern) {
    this.check(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.matched = function() {
    return this.lastMatch.str != null;
  };

  StringScanner.prototype.matchSize = function() {
    if (this.matched()) {
      return this.match().length;
    } else {
      return null;
    }
  };

  StringScanner.prototype.peek = function(len) {
    return this.str.substr(this.pos, len);
  };

  StringScanner.prototype.pointer = function() {
    return this.pos;
  };

  StringScanner.prototype.setPointer = function(pos) {
    pos = +pos;
    if (pos < 0) {
      pos = 0;
    }
    if (pos > this.str.length) {
      pos = this.str.length;
    }
    return this.pos = pos;
  };

  StringScanner.prototype.reset = function() {
    this.lastMatch.reset();
    this.pos = 0;
    return this;
  };

  StringScanner.prototype.rest = function() {
    return this.str.substr(this.pos);
  };

  StringScanner.prototype.scan = function(pattern) {
    var chk;
    chk = this.check(pattern);
    if (chk != null) {
      this.pos += chk.length;
    }
    return chk;
  };

  StringScanner.prototype.scanUntil = function(pattern) {
    var chk;
    chk = this.checkUntil(pattern);
    if (chk != null) {
      this.pos += chk.length;
    }
    return chk;
  };

  StringScanner.prototype.skip = function(pattern) {
    this.scan(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.skipUntil = function(pattern) {
    this.scanUntil(pattern);
    return this.matchSize();
  };

  StringScanner.prototype.string = function() {
    return this.str;
  };

  StringScanner.prototype.terminate = function() {
    this.pos = this.str.length;
    this.lastMatch.reset();
    return this;
  };

  StringScanner.prototype.toString = function() {
    var data, positition;
    positition = this.eos() ? 'fin' : this.pos + "/" + this.str.length;
    data = this.str.length > 8 ? (this.str.substr(0, 5)) + "..." : this.str;
    return "#<StringScanner " + position + " @ " + data + ">";
  };

  return StringScanner;

})();

StringScanner.prototype.beginningOfLine = StringScanner.prototype.bol;

StringScanner.prototype.clear = StringScanner.prototype.terminate;

StringScanner.prototype.dup = StringScanner.prototype.clone;

StringScanner.prototype.endOfString = StringScanner.prototype.eos;

StringScanner.prototype.exist = StringScanner.prototype.exists;

StringScanner.prototype.getChar = StringScanner.prototype.getch;

StringScanner.prototype.position = StringScanner.prototype.pointer;

StringScanner.StringScanner = StringScanner;

module.exports = StringScanner;

//# sourceMappingURL=data:application/json;base64,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
